const sharedConfig:any = {
    //APP_MODE: 'dev',
    APP_MODE: 'prod',
};

export default sharedConfig;
